// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CloseButton-cls1___dc4083e882a8e1d121b{/*!*/}.CloseButton-cls2__e9e35255689ef0456b37{background:transparent;border:0;color:#fff;font-size:14px;opacity:.6;padding:15px;position:absolute}.CloseButton-cls2__e9e35255689ef0456b37.CloseButton-dark___dca9ebc886ffc112178{color:#000}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CloseButton-cls1___dc4083e882a8e1d121b",
	"cls2": "CloseButton-cls2__e9e35255689ef0456b37 CloseButton-cls1___dc4083e882a8e1d121b",
	"dark": "CloseButton-dark___dca9ebc886ffc112178"
};
export default ___CSS_LOADER_EXPORT___;
